import PropTypes from "prop-types"
import { intComma } from "humanize-plus"

import "./services_connected.scss"

const ServicesConnected = ({ servicesTotal, topServices, servicesUrl }) => (
  <div className="stat-box category-service-stat-box" styleName="services">
    <h3>Services</h3>
    <div className="content">
      <div>
        <p className="stat">{intComma(servicesTotal)}</p>
        <p className="caption">Unique services your service is connected to</p>
        <p>
          <a className="caption" href={servicesUrl}>
            View all {intComma(servicesTotal)} services
          </a>
        </p>
      </div>
      <div styleName="services-top">
        <h4>Top 3 services</h4>
        <ul>
          {topServices.map(item => (
            <li
              key={item.module_name}
              style={{ backgroundColor: `#${item.brand_color}` }}
            >
              <a href={`${servicesUrl}/${item.module_name}`}>
                <img src={item.monochrome_image_url} alt={item.name} />
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
)

ServicesConnected.propTypes = {
  servicesTotal: PropTypes.number.isRequired,
  topServices: PropTypes.array.isRequired,
  servicesUrl: PropTypes.string.isRequired,
}

export default ServicesConnected
